// extracted by mini-css-extract-plugin
export var background = "styles-module--background--31xlE";
export var container = "styles-module--container--1y0Gc";
export var faq = "styles-module--faq--tnhBN";
export var answer = "styles-module--answer--gGrAQ";
export var fadeIn = "styles-module--fadeIn--17lP0";